import { CommonModule } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthFlowType } from '../../types/auth-form.type';

@Component({
  selector: 'app-toggle',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './toggle.component.html',
  styleUrl: './toggle.component.scss',
  host: {
    '[class.auth-toggle-host--parent]': 'variant() === "parent"',
  },
})
export class ToggleComponent {
  variant = input<'default' | 'parent'>('default');
  public selectedAuthFlow = output<AuthFlowType>();

  public leftIsActive = signal(true);

  public toggleLeft() {
    if (!this.leftIsActive()) {
      this.leftIsActive.set(!this.leftIsActive());
      this.selectedAuthFlow.emit('signup');
    }
  }

  public toggleRight() {
    if (this.leftIsActive()) {
      this.leftIsActive.set(!this.leftIsActive());
      this.selectedAuthFlow.emit('signin');
    }
  }
}
